module.exports = __webpack_public_path__ + "static/media/awfxcg32_1301.33bdad39.ico";